import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import Variables from "../styles/variables.scss";
const SVG = props => (_jsxs("svg", { width: "17px", height: "17px", viewBox: "0 0 17 17", version: "1.1", children: [_jsx("title", { children: "icon/klokke_sort" }), _jsx("desc", { children: "Created with Sketch." }), _jsx("defs", {}), _jsx("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: _jsx("g", { id: "icon/klokke_sort", transform: "translate(1.000000, 1.000000)", stroke: props.color, children: _jsxs("g", { id: "Group-3", children: [_jsx("circle", { id: "Oval-115", cx: "7.5", cy: "7.5", r: "7.5" }), _jsx("path", { d: "M7.5,3 L7.5,8", id: "Line-38", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M7.5,8 L10,11", id: "Line", strokeLinecap: "round", strokeLinejoin: "round" })] }) }) })] }));
SVG.propTypes = {
    color: PropTypes.string,
};
SVG.defaultProps = {
    color: Variables.blackSecondary,
};
export default SVG;
